module.exports = __webpack_public_path__ + "img/qiji.a317da49.png";